import apiClient from '@/lib/api-client';

export interface PortalSettingsSnapshot {
  orderStalenessDays: number;
  leadtimeMinObservations: number;
  customerStepLabels: Record<string, unknown>;
}

export type SettingKey = 'orderStalenessDays' | 'leadtimeMinObservations' | 'customerStepLabels';

/** h3-6 (FR16/FR19a/FR41): admin-only settings snapshot. */
export async function getSettings(): Promise<PortalSettingsSnapshot> {
  const response = await apiClient.get<{ data: PortalSettingsSnapshot }>('/admin/settings');
  return response.data.data;
}

/** A write is always per-key with a required audit note (FR16/FR19a). */
export async function updateSetting(key: SettingKey, value: unknown, auditNote: string): Promise<PortalSettingsSnapshot> {
  const response = await apiClient.put<{ data: PortalSettingsSnapshot }>(`/admin/settings/${key}`, { value, auditNote });
  return response.data.data;
}
